import { ActionIcon, Badge, Button, Card, Group, Text } from '@mantine/core';
import { useAuth } from 'contexts/auth';
import { FC } from 'react';
import { BASE_SPINDLE_BE_URL } from 'utils/constants';

interface IProps {
  name: string;
  type: string;
  description: string;
  id: string;
  onEdit: Function;
}

const IntegrationCard: FC<IProps> = ({ name, type, description, id, onEdit }) => {
  const { user } = useAuth();
  const addIntegrationButtonHandler = () => {
    onEdit(id);
  };

  return (
    <Card style={{ display: 'flex', flexDirection: 'column' }} shadow="sm" p="lg">
      <Group position="apart" style={{ marginBottom: 5 }}>
        <Text weight={500}>{name}</Text>
      </Group>

      <Text style={{ paddingBottom: '40px' }} size="sm">
        {description}
      </Text>

      <Group grow style={{ marginTop: 'auto' }}>
        <Button
          onClick={() =>
            window.open(`${BASE_SPINDLE_BE_URL}/graphiql?id=${user.accountId}`, '_blank')
          }
          size="xs"
          color="blue"
          fullWidth
        >
          Open Explorer
        </Button>
        <Button fullWidth size="xs" color="dark" onClick={addIntegrationButtonHandler}>
          Modify API
        </Button>
      </Group>
    </Card>
  );
};

export default IntegrationCard;
